import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@campaignhub/suit-theme'

interface CreditsToolsProps {
  callbacks: {},
}

const CreditsTools = (props: CreditsToolsProps) => {
  const { callbacks } = props

  // return (
  //   <Tools>
  //     <Button
  //       buttonStyle="secondaryUtility"
  //       icon={<FontAwesomeIcon icon={faExclamationCircle} />}
  //       iconPosition="left"
  //       onClick={() => console.log('Credit Tool Button Click')}
  //       size="medium"
  //     >
  //       Credit Tool Button
  //     </Button>
  //   </Tools>
  // )
}

export default CreditsTools
